import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzCategories() {
    const source = axios.CancelToken.source();

    const [categories, setCategories] = useState<vp.RailzCategory[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchCategories = async (requestParams: vp.RailzCategories) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzCategories(requestParams, source);
        setCategories(res.Categories);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setCategories(undefined);
    };

    return {
      categories,
      fetchCategories,
      reset,
    };
  };
});

export default initHook({});
